module.exports = __webpack_public_path__ + "img/open_account2.8d7262c4.png";